
export function ajaxPost(params) {
    var data =
        {
            Payload: params.data,
            SessionID:global.sessionID,
            StartIndex: params.startIndex != null ? params.startIndex : 0,
            MaxData: params.maxData != null ? params.maxData : 0,
        };
    return window.fetch(window.apihost + params.url,
        {
            credentials:params.credentials != null ? 'include' : 'same-origin',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            method: 'post',
            body: JSON.stringify(data)
        }).catch((err)=>
        {
            if( params.onError != null )
                params.onError(err);

            return { then: params.finally };
        })
        .then((response) => {
            if( !response.ok )
            {
                if( params.onError != null )
                    params.onError(response);

                    return { then: params.finally }; // end/break the chain
                }
            return response.json();
        }).then((json) => {
            return params.onSuccess(JSON.parse(json.JsonData),params.sender);
        }).then( () =>
        {
            params.finally();
        });
}

export function ajaxGet(params) {
    window.fetch(window.apihost + params.url,
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            method: 'get',
        })
        .catch((err)=>
        {
            if( params.onError != null )
                params.onError(err);

            return { then: params.finally };
        })
        .then((response) => {
            if( !response.ok )
            {
                if( params.onError != null )
                    params.onError(response);

                    return { then: params.finally }; // end/break the chain
                }
            return response.json();
        }).then((json) => {
            params.onSuccess(json,params.sender, params.attachment);
        }).then( () =>
        {
            params.finally();
        });
}




// WEBPACK FOOTER //
// ./src/ajax.js